<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const props = defineProps({
  activePage: {
    type: String,
    required: true,
    validator: value => ['inbox', 'monitoring', 'performance'].includes(value),
  },
  showManagementPages: {
    type: Boolean,
    default: false,
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
const { t } = useI18n();

const pages = computed(() => [
  {
    key: 'inbox',
    routeName: 'inbox_view',
    title: t('CUSTOMER_SERVICE_WORKSPACE.INBOX.TITLE'),
    description: t('CUSTOMER_SERVICE_WORKSPACE.INBOX.DESCRIPTION'),
    visible: true,
  },
  {
    key: 'monitoring',
    routeName: 'conversation_monitoring',
    title: t('CUSTOMER_SERVICE_WORKSPACE.MONITORING.TITLE'),
    description: t('CUSTOMER_SERVICE_WORKSPACE.MONITORING.DESCRIPTION'),
    visible: props.showManagementPages,
  },
  {
    key: 'performance',
    routeName: 'performance_dashboard',
    title: t('CUSTOMER_SERVICE_WORKSPACE.PERFORMANCE.TITLE'),
    description: t('CUSTOMER_SERVICE_WORKSPACE.PERFORMANCE.DESCRIPTION'),
    visible: props.showManagementPages,
  },
]);

const routeFor = page => ({
  name: page.routeName,
  params: { accountId: route.params.accountId },
});
</script>

<template>
  <nav
    :aria-label="$t('CUSTOMER_SERVICE_WORKSPACE.ARIA_LABEL')"
    class="grid gap-2"
    :class="compact ? 'grid-cols-1' : 'md:grid-cols-3'"
  >
    <RouterLink
      v-for="page in pages.filter(item => item.visible)"
      :key="page.key"
      :to="routeFor(page)"
      class="rounded-lg border px-3 py-2 transition-colors"
      :class="
        activePage === page.key
          ? 'border-n-brand bg-n-brand-2 text-n-brand'
          : 'border-n-weak bg-n-surface-2 text-n-slate-11 hover:border-n-strong hover:bg-n-alpha-1'
      "
    >
      <span class="block text-sm font-medium">
        {{ page.title }}
      </span>
      <span
        v-if="!compact"
        class="mt-0.5 block text-xs leading-5 text-n-slate-10"
      >
        {{ page.description }}
      </span>
    </RouterLink>
  </nav>
</template>
